import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import { Box } from '../../../../../../layout/Box';
import { Dropdown } from '../../../../../../inputs/Dropdown';
import { getFillColorFromItemVariant, getStrokeColorFromItemVariant, getTextColorFromItemVariant } from '../../utilites';
import { Icon } from '../../../../../../imagesAndIcons/Icon';
import { Text } from '../../../../../../typography/Text';
import styled from 'styled-components';

var itemRenderer = function itemRenderer(item) {
  var toRender = [];

  if (item.icon) {
    toRender.push(React.createElement(Box, {
      display: Box.Display.InlineBlock,
      key: item.label + "-icon",
      mr: 2
    }, React.createElement(item.icon, {
      fill: item.disabled ? Icon.Fill.Gray5 : getFillColorFromItemVariant(item.variant),
      size: Icon.Size.Sm,
      stroke: item.disabled ? Icon.Stroke.Gray3 : getStrokeColorFromItemVariant(item.variant),
      verticalAlign: Icon.VerticalAlign.Bottom
    })));
  }

  toRender.push(React.createElement(Text, {
    color: item.disabled ? Text.Color.Gray2 : getTextColorFromItemVariant(item.variant),
    key: item.label + "-label",
    size: Text.Size.Sm,
    weight: Text.Weight.Medium
  }, item.label));

  if (item.description) {
    toRender.push(React.createElement(Description, {
      key: item.label + "-description"
    }, React.createElement(Text, {
      color: item.disabled ? Text.Color.Gray2 : getTextColorFromItemVariant(item.variant),
      el: Text.Element.P,
      size: Text.Size.Sm
    }, item.description)));
  }

  return React.createElement(Box, {
    pv: 0.5
  }, item.customNode || toRender);
};

var ItemMenu =
/** @class */
function (_super) {
  __extends(ItemMenu, _super);

  function ItemMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      menuIsOpen: _this.props.menuIsOpen
    };

    _this.handleItemClick = function (item, _index, e) {
      if (item.onClick) {
        item.onClick(e);
      }
    };

    _this.handleOnOpen = function () {
      _this.setState({
        menuIsOpen: true
      });
    };

    _this.handleOnClose = function () {
      _this.setState({
        menuIsOpen: false
      });
    };

    return _this;
  }

  ItemMenu.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        items = _a.items,
        label = _a.label,
        rightAlign = _a.rightAlign;
    return React.createElement(Dropdown, {
      ariaLabel: label,
      displayValue: children,
      hideCaret: true,
      isOpen: this.state.menuIsOpen,
      noHandleStyle: true,
      onClose: this.handleOnClose,
      onOpen: this.handleOnOpen,
      openOnHover: true,
      rightAlign: rightAlign,
      width: Dropdown.Width.MaxContent
    }, React.createElement(Dropdown.List, {
      hideLines: true,
      itemRenderer: itemRenderer,
      items: items || [],
      onSelectItem: this.handleItemClick
    }));
  };

  ItemMenu.defaultProps = {
    items: []
  };
  return ItemMenu;
}(React.Component);

export { ItemMenu };
var Description = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: ", ";\n"], ["\n    max-width: ", ";\n"])), function (props) {
  return props.theme.units.getValue(26);
});
var templateObject_1;